module.exports = {"validation":{"required":"Dieser Wert ist erforderlich","email":"Ungültige E-Mail-Adresse"}}